var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"consult"},[_c('g-header',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_vm._v(" ")]},proxy:true}])},[_vm._v("电话咨询")]),_c('section',{staticClass:"phone"},[_c('div',[_vm._v("点击拨打电话:")]),_c('a',{attrs:{"href":`tel:${_vm.sharePhone}`}},[_vm._v(_vm._s(_vm.sharePhone))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }